module.exports = __webpack_public_path__ + "media/images/new_home/sponsor-logo-6-daf1f96402b8c2d5d3c6e7ca959fab78.png";